import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import orange from '@material-ui/core/colors/orange';
import { default as MuiButton } from '@material-ui/core/Button';
import { darken, lighten } from '@material-ui/core/styles/colorManipulator';

const greenColor = green[600];
const redColor = red[500];
const orangeColor = orange[800];
const whiteColor = '#ffffff';

const styles = (theme) => ({
    ...generateColorStyle('green', greenColor, theme),
    ...generateColorStyle('red', redColor, theme),
    ...generateColorStyle('orange', orangeColor, theme),
    ...generateColorStyle('white', whiteColor, theme),
});

function generateColorStyle(name, color, theme) {
    return {
        [name]: {
            color,
            borderColor: color,
            '&:hover': {
                backgroundColor: lighten(color, 0.9),
            },
        },
        [name + 'Contained']: {
            color: theme.palette.getContrastText(color),
            backgroundColor: color,
            '&:hover': {
                backgroundColor: darken(color, 0.2),
            },
        },
    };
}

class Button extends React.Component {
    render() {
        const { classes, className, children, color, variant, ...rest } = this.props;

        const style =
            variant === 'contained' || variant === 'fab' || variant === 'extendedFab' ? `${color}Contained` : color;

        let muiColor;
        let customClass;

        if (classes[style]) {
            customClass = classes[style];
        } else {
            muiColor = color;
        }

        return (
            <MuiButton
                variant={variant}
                color={muiColor}
                className={classNames(className, customClass)}
                disableElevation
                {...rest}
            >
                {children}
            </MuiButton>
        );
    }
}

export default withStyles(styles)(Button);
